import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Phone } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
import { SITE_IMAGES } from '../../components/siteImages';
import { SELF_DEFENSE_WHAT_YOU_LEARN } from './selfDefenseContent';
export function SelfDefenseHero() {
  return <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2985">
      <div className="absolute inset-0 opacity-20" data-id="element-2986">
        <img src={SITE_IMAGES.selfDefense} alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2987" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2988" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2989">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2990">
          <div className="flex flex-col items-start" data-id="element-2991">
            <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2992">
              Self-Defense
            </div>
            <div className="mb-8" data-id="element-2993">
              <SocialProofBar data-id="element-2994" />
            </div>
            <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2995">
              Adult Self-Defense Classes in Farmington Hills
            </h1>
            <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2996">
              Build awareness, confidence and practical safety skills in a
              supportive Storm Taekwondo training environment. Beginner-friendly
              for adults — no prior experience needed.
            </p>

            <ul className="flex flex-col gap-3 mb-10" data-id="element-2997">
              {SELF_DEFENSE_WHAT_YOU_LEARN.slice(0, 4).map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-2998">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-2999" />
                  <span data-id="element-3000">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-3001">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-3002">
                Ask About Self-Defense Classes
              </Link>
              <a href="tel:517-220-0621" className="btn-secondary" data-id="element-3003">
                Call 517-220-0621
              </a>
            </div>
            <TrustBadges data-id="element-3004" />
          </div>

          <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-3005">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-subtle-gray aspect-[4/5]" data-id="element-3006">
              <img src={SITE_IMAGES.selfDefense} alt="Storm Taekwondo Training" className="block w-full h-full object-cover" data-id="element-3007" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/40 to-transparent" data-id="element-3008" />
              <div className="absolute bottom-0 left-0 right-0 p-8 flex flex-col gap-4" data-id="element-3009">
                <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide w-fit" data-id="element-3010">
                  Get Self-Defense Class Info
                </div>
                <h3 className="text-3xl text-white m-0 leading-tight" data-id="element-3011">
                  Ready to get started?
                </h3>
                <Link to="/SignMeUp" className="btn-primary w-full text-center" data-id="element-3012">
                  Ask About Self-Defense Classes
                </Link>
                <a href="tel:517-220-0621" className="text-white font-bold text-center hover:text-storm-red transition-colors flex items-center justify-center gap-2" data-id="element-3013">
                  <Phone className="w-4 h-4" data-id="element-3014" />
                  Or call 517-220-0621
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}